module.exports = __webpack_public_path__ + "img/login-sanpedroysanpablo.9a5eeaf5.svg";